import {Button} from "@/components/ui/button.tsx";
import {ArrowDown, ArrowUp, Trash2} from "lucide-react";
import {ButtonGroup} from "@/components/ui/button-group.tsx";

interface UseFieldArrayOptionsProps {
    index: number;
    array: {
        fields: readonly unknown[];
        move: (from: number, to: number) => void;
        remove: (index: number) => void;
    };
}

export default function UseFieldArrayOptions({index, array}: UseFieldArrayOptionsProps) {

    return (
        <ButtonGroup>
            <ButtonGroup>
                <Button type="button" size="icon-sm" variant="ghost" title="Nach oben"
                        disabled={index === 0}
                        onClick={() => array.move(index, index - 1)}
                ><ArrowUp/></Button>
                <Button type="button" size="icon-sm" variant="ghost" title="Nach unten"
                        disabled={index === array.fields.length - 1}
                        onClick={() => array.move(index, index + 1)}
                ><ArrowDown/></Button>
            </ButtonGroup>
            <ButtonGroup>
                <Button type="button" size="icon-sm" variant="ghost" title="Eintrag löschen"
                        className="text-destructive hover:text-destructive"
                        onClick={() => array.remove(index)}><Trash2/></Button>
            </ButtonGroup>
        </ButtonGroup>
    )

}
